module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_fails.js
// module id = 83
// module chunks = 0 1 2 3 4 5 6 7 8 9 10